import { render, staticRenderFns } from "./smsList.vue?vue&type=template&id=60d9abb1&scoped=true&"
import script from "./smsList.vue?vue&type=script&lang=babel&"
export * from "./smsList.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d9abb1",
  null
  
)

export default component.exports